// @flow
import * as React from 'react';
import type { Line } from 'esm-web-pro/containers/pages/network/objects/cable/create/CreateCable';
import { Box, Text } from 'grommet';
import CablePipeField from 'esm-web-pro/containers/pages/network/forms/fields/CablePipeField';
import { FormattedMessage } from 'react-intl';


type Props = {
    line: Line,
    onChange: (choice: string) => void,
    disabled: boolean,
};

const CableLine = (props: Props) => {
    const {
        line: {
            options, value, startNumber, endNumber,
        }, onChange, disabled,
    } = props;

    const choices = {};
    Object.keys(options).forEach((option) => {
        choices[option] = options[option].name;
    });

    let pipes;
    if (value && options[value].pipes) {
        pipes = Object.values(options[value].pipes);
    }

    const key = `${startNumber}-${endNumber}`;
    return (
        <Box key={key}>
            <CablePipeField
                lineKey={key}
                startNumber={startNumber}
                endNumber={startNumber + 1}
                onChange={onChange}
                choices={choices}
                disabled={disabled}
                value={value}
            />
            {value === 'no-pipe' ? (
                <Text
                    color="orange"
                    margin={{ top: '10px' }}
                >
                    <FormattedMessage
                        id="no-pipe-choice"
                        defaultMessage="The cable will go underground no pipe"
                    />
                </Text>
            ) : null}
            {pipes && pipes.map((p: Object, i): React.Element<Box> => {
                const startSegmentNumber = i === 0 ? startNumber : Number(`${startNumber}.${i}`);
                const endSegmentNumber = i === pipes.length - 1 ? startNumber + 1 : Number(`${startNumber}.${i + 1}`);
                return (
                    <Box key={`${startSegmentNumber} - ${endSegmentNumber}`}>
                        <Text size="medium">
                            {`${startSegmentNumber} - ${endSegmentNumber} ${p.name}`}
                        </Text>
                    </Box>
                );
            })}
        </Box>
    );
};

export default CableLine;
